module.exports = __webpack_public_path__ + "static/img/takeaway.78d39a3f.png";